import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { debounce } from "lodash";
import {
  Avatar,
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Input,
  Menu,
  Modal,
  Row,
  Switch,
  Table,
  Tooltip,
  message,
} from "antd";
import {
  DeleteOutlined,
  DingtalkOutlined,
  DollarOutlined,
  EditOutlined,
  EyeOutlined,
  FileSearchOutlined,
  FormOutlined,
  LockOutlined,
  MenuOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { SetRoute } from "../scripts/action";
import { CheckPermission, PriceFormat } from "../scripts/helpers";
import { Constants, Permissions } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import PaginationInfo from "../components/PaginationInfo";
import CreditForm from "../forms/Credit";
import PermissionForm from "../forms/Permission";
import UserForm from "../forms/User";
import ReportView from "../views/Report";
import UserView from "../views/User";
import moment from "moment-jalaali";

class UsersPage extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      filter: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      selected: {},

      userType: {
        guest: Resources.guest,
        villaOwner: Resources.villaOwner
      },
    };

    this.formRef = React.createRef();
    this.creditFormRef = React.createRef();
    this.permissionFormRef = React.createRef();

    this.handleFilter = debounce(this.handleFilter, 1000);
  }

  fetch = (params = {}) => {
    const { filterLevel, filterSearch } = this.state;

    params.q = filterSearch;
    params.level = filterLevel;

    this.setState({ loading: true });

    API.user
      .list(params)
      .then((result) => {
        if (result.data) {
          this.setState({
            loading: false,
            data: result.data,
            pagination: {
              ...this.state.pagination,
              ...{
                current: result.current_page,
                pageSize: result.per_page,
                total: result.total,
              },
            },
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };



  showForm = (user = {}) => {
    this.setState({ visibleForm: true, selected: user });

    setTimeout(() => {
      this.formRef.current.handleDidMount(user);
    }, 0);
  };

  hideForm = () => {
    this.setState({ visibleForm: false });

    setTimeout(() => {
      this.formRef.current.handleWillUnmount();
    }, 0);
  };


  handleFilter = (value, obj) => {
    const state = {};
    state[obj] = value;

    this.setState(state);

    setTimeout(() => {
      this.fetch({ page: 1 });
    }, 0);
  };


  handleStatus = (record) => {
    Modal.confirm({
      title: record.status == "active"
        ? Resources.confirmUserDeactivate
        : Resources.confirmUserActivate,
      okText: Resources.yes,
      okType: record.status ? "danger" : "primary",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.user
          .statusUpdate(record)
          .then((result) => {
            this.setState({ loading: false });

            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {

            this.setState({ loading: false });
          });
      },
    });
  };
  handleIsAdmin = (record) => {
    Modal.confirm({
      title: record.isAdmin
        ? Resources.confirmDeactivate
        : Resources.confirmActivate,
      okText: Resources.yes,
      okType: record.status ? "danger" : "primary",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.user
          .isAdminUpdate(record)
          .then((result) => {
            this.setState({ loading: false });

            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {

            this.setState({ loading: false });
          });
      },
    });
  };



  handleDelete = (record) => {
    Modal.confirm({
      title: Resources.confirmDeleteUser,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.user
          .delete(record)
          .then((result) => {

            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handleSubmit = (values) => {
    const action = this.state.selected._id ? API.user.update : API.user.add;

    this.setState({ submitting: true });

    action(this.state.selected._id, values)
      .then((result) => {
        this.setState({ submitting: false });
        this.hideForm();
        this.fetch({ page: this.state.pagination.current });
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };

  handleTableChange = (pagination) => {
    this.fetch({ page: pagination.current });
  };

  componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;

    onSetRoute({ openKey: parentName, selectedKey: routeName });

    this.fetch({ page: 1 });
  }

  getUserType(val){
    if (val == "guest")
      return Resources.guest

    if (val == "villa_owner")
      return Resources.villaOwner

    return ""
  }

  render() {
    const {
      data,
      decreaseCredit,
      loading,
      pagination,
      selected,
      submitting,
      visibleCredit,
      visibleForm,
      visiblePermission,
      visibleReport,
      visibleView,
    } = this.state;
    const { permissions } = this.props;

    const columns = [
      {
        title: Resources.firstName,
        dataIndex: "firstName",

      },
      {
        title: Resources.lastName,
        dataIndex: "lastName",

      },
      {
        title: Resources.mobile,
        dataIndex: "phone",
        className: "col-center",
      },
      // {
      //   title: Resources.type,
      //   dataIndex: "user_type",
      //   className: "col-center",
      //   render: (val, record) => this.getUserType(val),
      // },


      {
        title: Resources.status,
        dataIndex: "status",
        className: "col-center",
        render: (val, record) => (
          <Switch
            size="small"
            checked={val == "active"}
            onClick={() => this.handleStatus(record)}
            // disabled={!permissions.action}
          />
        ),
      },

      {
        title: Resources.admin,
        dataIndex: "isAdmin",
        className: "col-center",
        render: (val, record) => (
            <Switch
                size="small"
                checked={(val) ? true : false}
                onClick={() => this.handleIsAdmin(record)}
                // disabled={!permissions.action}
            />
        ),
      },
      {
        title: Resources.birthdate,
        dataIndex: "birthDate",
        className: "col-center",
        render: (value) => {
          if(value) {
            const [date, time] = moment(value)
                .format(Constants.jDateTimeFormat)
                .split(" ");

            return (
                <>
                  <span className="name">{date}</span>
                  {/*<small className="desc">{time}</small>*/}
                </>
            )
          }else{
            return ""
          }


        },
      },
      {
        title: Resources.image,
        dataIndex: 'id_store',
        className: 'col-center col-avatar',
        width: '60px',
        render: val => val ? <Tooltip title={<Avatar src={`${Constants.imagePathUser}${val.location}`} shape="square" size={140} />}><Avatar src={`${Constants.imagePathUser}${val.location}`} shape="square" size="small" /></Tooltip> : <Avatar shape="square" size="small" />
    }
    ];

    const options = [
      { label: Resources.admin, value: "admin" },
      { label: Resources.user, value: "user" },
      { label: Resources.operator, value: "operator" },
    ];

      columns.push({
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "80px",
        render: (val, record) => (
          <Dropdown
            overlay={
              <Menu>

                <Menu.Item>
                  <span onClick={() => this.showForm(record)}>
                    <EditOutlined /> {Resources.edit}
                  </span>
                </Menu.Item>

                <Menu.Item>
                  <span onClick={() => this.handleDelete(record)}>
                    <DeleteOutlined /> {Resources.delete}
                  </span>
                </Menu.Item>
              </Menu>
            }
          >
            <Button type="link" icon={<MenuOutlined />} />
          </Dropdown>
        ),
      });


    return (
      <Fragment>
        <Breadcrumb>
          <Breadcrumb.Item>{Resources.users}</Breadcrumb.Item>
        </Breadcrumb>
        <div className="ant-content">
          <Row gutter={24}>
              <Col xs={24} md={4}>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => this.showForm()}
                  block
                >
                  {Resources.add}
                </Button>
              </Col>

          </Row>
        </div>
        <div className="ant-content">
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            onChange={this.handleTableChange}
            pagination={pagination}
            size="small"
            rowKey="id"
            scroll={{ x: 900 }}
          />
          {!!pagination.total && (
            <PaginationInfo
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
            />
          )}
        </div>


        <UserForm
          ref={this.formRef}
          onCancel={this.hideForm}
          onSubmit={this.handleSubmit}
          submitting={submitting}
          visible={visibleForm}
        />

      </Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      permissions: {
        action: CheckPermission(state.app.user, Permissions.user_option),
        add: CheckPermission(state.app.user, Permissions.user_store),
      },
    };
  },
  (dispatch) => {
    return {
      onSetRoute: (data) => dispatch(SetRoute(data)),
    };
  }
)(UsersPage);
